import { detect, fromNavigator, fromUrl } from '@lingui/detect-locale';
import { i18n } from '@lingui/core';

const pluralsData: Record<string, Function> = require('make-plural/plurals')

async function activate(locale:string) {
  locale = locale.split("-")[0]
  if (locale === "nb") locale = "no"
  const { messages } = await import(`../locales/${locale}/messages.js`)
  setTimeout(() => {
    i18n.loadLocaleData(locale, { plurals: pluralsData[locale] })
    i18n.load(locale, messages)
    i18n.activate(locale)
    console.log(locale)
  }, 0)
}

export async function detectLanguage () {
  const defaultLanguage = "en"
  let lang = detect(fromUrl("lang"), fromNavigator(), defaultLanguage)
  await activate(lang as string)
}